import { FormGroup } from '@angular/forms';

export class Education {
    public _id: string;
    public title: string;
    public educationLevel: string;
    public educationLevelId: string;
    public subject: string;
    public year: number;
    public institute: string;
    public description: string;

    public setTitle(educationLevel: string): void {
        this.title = `${educationLevel} - ${this.subject}`;
    }

    public static parseForm(form: FormGroup): Education {
        let id = '_' + Math.random().toString(36).substr(2, 9);
        let education = new Education();
        education = Object.assign(education, form.value);
        education.educationLevelId = education.educationLevel;
        education._id = id;
        return education;
    }

    public static parse(jsonData): Education {
        let education = new Education();
        education = Object.assign(education, jsonData);
        return education;
    }
}
